import { BlankView } from "@/components";
import { constantsData, routesUrlsData } from "@/data";

export const AccessDeniedBlankView = () => (
    <BlankView
        description={constantsData.msgs.accessDenied}
        actionBtnData={{
            hasLink: true,
            linkRouteUrl: routesUrlsData.home,
            linkText: constantsData.buttons.goToHome,
        }}
        hasActionBtn
        hasDescription
    />
);
